import React, { useRef } from "react";

/**
 * useGridRef
 * Useful for referring to Div elements when applying CSS classes
 * @returns Ref and a callback function to update the ref
 *
 */
export const useGridRef = <T extends HTMLElement>(): [React.RefObject<T>, (fn: (input: T) => void) => void] => {
  const ref = useRef<T>(null);
  return [
    ref,
    (fn: (input: T) => void) => {
      fn(ref!.current!);
    },
  ];
};
